var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import Component from '@arco-design/web-react/es/Radio';
import { useConfigContext } from '../config-provider';
function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
var ArcoRadioGroup = Component.Group;
var Radio = function (props) {
    var className = props.className;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-radio";
    return React.createElement(Component, __assign({}, props, { className: cx(className, prefixCls) }));
};
var RadioGroup = function (props) {
    var className = props.className, options = props.options, disabled = props.disabled, children = props.children, rest = __rest(props, ["className", "options", "disabled", "children"]);
    var common = useConfigContext().prefixCls;
    var radioPrefixCls = common + "-radio";
    var radioGroupPrefixCls = common + "-radio-group";
    var _children = options && Array.isArray(options) ?
        options.map(function (option, index) {
            if (isObject(option)) {
                return (React.createElement(Radio, { key: option.value, disabled: disabled || option.disabled, value: option.value, className: radioPrefixCls }, option.label));
            }
            return (React.createElement(Radio, { key: index, value: option, disabled: disabled, className: radioPrefixCls }, option));
        }) : children;
    return React.createElement(ArcoRadioGroup, __assign({}, rest, { disabled: disabled, className: cx(className, radioGroupPrefixCls) }), _children);
};
Radio.Group = RadioGroup;
var RadioComponent = Radio;
RadioComponent.displayName = 'Radio';
export default RadioComponent;
//# sourceMappingURL=index.js.map